
<template>
  <v-container fluid>
    <v-card style="border-radius:12px" v-if="oneClient">
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{is_new? 'Novo' : 'Editando'}} Cliente</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="overflow-y:auto; max-height: 720px">
        <v-form ref="formClient" v-model="validClient" lazy-validation>
          <v-container fluid class="pa-0 px-1" >
            <v-expansion-panels popout v-model="panels">
              <v-expansion-panel class="mt-1" style="border-radius:8px">
                <v-expansion-panel-header>
                  <v-row align="center">
                    <div class="caption dark-grey--text mr-1">Dados de</div>
                    <div class="dark-grey--text text--darken-3">{{oneClient.name}}</div>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content >
                  <v-container grid-list-xs>
                    <v-radio-group mandatory v-model="oneClient.client_is" row>
                      <v-radio value="natural" color="success">
                        <template v-slot:label>
                          <div><strong class="success--text">Pessoa Física</strong></div>
                        </template>
                      </v-radio>
                      <v-radio value="corporate" color="secondary">
                        <template v-slot:label>
                          <div><strong class="secondary--text">Pessoa Jurídica</strong></div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-text-field v-model="oneClient.name" prepend-icon="mdi-account" :label="oneClient.client_is=='corporate'?'Nome Fantasia':'Nome'"></v-text-field>
                    <v-text-field v-model="oneClient.corporate_name" prepend-icon="mdi-domain" label="Razão Social" v-if="oneClient.client_is=='corporate'"></v-text-field>
                    <v-text-field v-model="oneClient.state_inscription" prepend-icon="mdi-information" label="Inscrição estadual" v-if="oneClient.client_is=='corporate'"></v-text-field>
                    <v-text-field v-model="oneClient.city_inscription" prepend-icon="mdi-information" label="Inscrição municipal" v-if="oneClient.client_is=='corporate'"></v-text-field>
                    <v-text-field v-model="oneClient.email" prepend-icon="mdi-email" label="Email"></v-text-field>
                    <v-text-field key="document" v-model="oneClient.document_number" prepend-icon="mdi-account-card-details" v-mask='oneClient.client_is =="natural"? mask_cpf: mask_cnpj' :label="oneClient.client_is=='natural'? 'CPF':'CNPJ'"></v-text-field>
                    <!-- <v-text-field v-model="oneClient.phones" prepend-icon="mdi-phone" v-mask='[mask_phone, mask_cellphone]'  label="Telefones"></v-text-field> -->
                    <v-text-field v-model="oneClient.responsible" prepend-icon="mdi-account-circle" label="Responsável" v-if="oneClient.client_is=='corporate'"></v-text-field>
                    <v-dialog v-model="dialog_address" persistent max-width="500px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" :value="oneClient.address.full_address" prepend-icon="mdi-map-marker" label="Endereço"></v-text-field>
                      </template>
                      <card-address v-if="dialog_address" :address="oneClient.address" @address-sent="oneClient.address = $event, dialog_address=false"></card-address>
                    </v-dialog>
                    <input-phone :phones.sync="oneClient.phones"></input-phone>
                    <v-layout row wrap justify-end v-if="false && !is_new">
                      <!-- PASSAR PARA DENTRO DO COMPONENTE ^ -->
                      <v-btn class="mx-4" text icon color="success" @click="submitSaveItem(idx)"> <v-icon style="font-size: 20px">mdi-content-save</v-icon> </v-btn>
                      <!-- <v-btn class="mx-4" text icon color="error" @click="remove_contract(idx)"> <v-icon style="font-size: 20px">mdi-delete</v-icon> </v-btn> -->
                    </v-layout>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>

            <v-row class="mt-4">
              <v-col>
                <v-subheader>Contratos</v-subheader>
                <v-expansion-panels popout>
                  <v-expansion-panel v-for="(contract, idx) in contracts" :key="`cc-${idx}`" class="mt-1" style="border-radius:8px">
                    <v-expansion-panel-header>
                      <v-row align="center">
                        <div class="caption dark-dark-grey--text mr-1">Contrato: </div>
                        <div class="dark-grey--text text--darken-3">{{oneClient.contracts.data[idx]? oneClient.contracts.data[idx].name : ''}}</div>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                      <v-container grid-list-xs>
                        <v-expansion-panels popout>
                          <v-expansion-panel class="mt-1" style="border-radius:8px">
                            <v-expansion-panel-header>
                              <v-row align="center">
                                <div class="caption dark-grey--text mr-1">Detalhes do contrato</div>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content >
                              <v-text-field v-model="oneClient.contracts.data[idx].name" prepend-icon="mdi-information" label="Nome/resumo"></v-text-field>
                              <v-row class="px-3">
                                <v-text-field v-model="oneClient.contracts.data[idx].total_ammount" prepend-icon="mdi-currency-brl" v-currency="currency" label="Valor honorário"></v-text-field>
                                <v-text-field v-model="oneClient.contracts.data[idx].parts" prepend-icon="mdi-cash-multiple" label="Parcelas"></v-text-field>
                              </v-row>
                              <v-row class="px-3">
                                <v-text-field v-model="oneClient.contracts.data[idx].ammount_payed" prepend-icon="mdi-currency-brl" v-currency="currency" label="Valor já pago" hint="Caso o contrato ja fora iniciado"></v-text-field>
                                <v-dialog ref="dialog_contract_date" v-model="modal_contract_date"  persistent width="290px" >
                                  <template v-slot:activator="{ on }">
                                    <!-- <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on" ></v-text-field> -->
                                    <v-text-field :value="formatDate(oneClient.contracts.data[idx].start_date)" prepend-icon="mdi-calendar" label="Início" readonly v-on="on"></v-text-field>
                                  </template>
                                  <v-date-picker v-model="oneClient.contracts.data[idx].start_date" scrollable locale="pt-br">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal_contract_date = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog_contract_date[idx].save(oneClient.contracts.data[idx].start_date)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-row>
                              <!-- <v-text-field v-model="oneClient.contracts.data[idx].payed_until" prepend-icon="mdi-search" label="Parcelas pagas até" hint=""></v-text-field> -->
                              <v-row class="px-3">
                                <v-text-field append-outer-icon="mdi-search" v-model="oneClient.contracts.data[idx].initial_fee_value" prepend-icon="mdi-currency-brl" v-currency="currency" label="Valor taxas iniciais"></v-text-field>
                                <v-switch inset v-model="oneClient.contracts.data[idx].initial_fee_paid" label="Taxas inicias pagas?"></v-switch>
                              </v-row>
                              <v-row class="px-3">
                                <v-select v-model="oneClient.contracts.data[idx].final_fee_type" :items="final_fee_types" item-text="name" item-value="value" prepend-icon="mdi-coin" label="Remuneração final"></v-select>
                                <v-text-field v-model="oneClient.contracts.data[idx].final_fee" prepend-icon="mdi-sack-percent" label="Porcent. da remuneração final" v-mask="mask_two_digits" hint="Entre 0 a 99%"></v-text-field>
                              </v-row>
                              <v-textarea v-model="oneClient.contracts.data[idx].comment" prepend-icon="mdi-chat mdi-flip-h" label="Comentários" rows="2"></v-textarea>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
<!-- name: string -->
<!-- total_ammount: decimal -->
<!-- payed_until: datetime -->
<!-- start_date: datetime -->
<!-- end_date: datetime -->
<!-- initial_fee_paid: boolean -->
<!-- initial_fee_value: decimal -->
<!-- ammount_payed: decimal -->
<!-- final_fee: decimal -->
<!-- final_fee_type: integer -->
<!-- comment: text -->
                        <v-subheader>Processos:</v-subheader>
                        <v-expansion-panels>
                          <v-expansion-panel v-for="(litigation, l_idx) in oneClient.contracts.data[idx].litigations" :key="`cc-${l_idx}`" class="mt-1" style="border-radius:8px">
                            <v-expansion-panel-header>
                              <v-row align="center">
                                <div class="caption dark-grey--text mr-1">Processo: </div>
                                <div class="dark-grey--text text--darken-3">{{litigation.name}}</div>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content >
                              <v-container grid-list-xs>
                                <v-row class="px-3">
                                  <v-text-field v-model="litigation.name" prepend-icon="mdi-information" label="Número do processo"></v-text-field>
                                  <v-select :items="all_progresses" v-model="litigation.progresses_attributes.name" item-text="text" item-value="value" label="Andamento" prepend-icon="mdi-debug-step-over" ></v-select>
                                  <v-dialog ref="dialog_c_litigation_date" width="290px" >
                                    <template v-slot:activator="{ on }">
                                      <!-- <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on" ></v-text-field> -->
                                      <v-text-field :value="formatDate(litigation.progresses_attributes.processed_at)" prepend-icon="mdi-calendar" label="Movimentado em" readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="litigation.progresses_attributes.processed_at" scrollable locale="pt-br">
                                      <v-spacer></v-spacer>
                                      <!-- <v-btn text color="primary" @click="modal_c_litigation_date = false">Cancel</v-btn> -->
                                      <v-btn text color="primary" @click="$refs.dialog_c_litigation_date[idx].save(litigation.progresses_attributes.processed_at)">OK</v-btn>
                                    </v-date-picker>
                                  </v-dialog>
                                  <v-text-field v-model="litigation.progresses_attributes.description" label="Descrição do andamento" prepend-icon="mdi-debug-step-over" ></v-text-field>
                                  <v-text-field v-model="litigation.progresses_attributes.internal_comment" label="Comentário interno andamento" prepend-icon="mdi-debug-step-over" ></v-text-field>
                                  <v-text-field v-model="litigation.folder" prepend-icon="mdi-folder-open" label="Pasta" hint="Para organização e controle interno"></v-text-field>
                                </v-row>
                                <v-dialog ref="dialog_c_litigation_date" v-model="modal_c_litigation_date"  persistent width="290px" >
                                  <template v-slot:activator="{ on }">
                                    <!-- <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on" ></v-text-field> -->
                                    <v-text-field :value="formatDate(litigation.start_date)" prepend-icon="mdi-calendar" label="Início" readonly v-on="on"></v-text-field>
                                  </template>
                                  <v-date-picker v-model="litigation.start_date" scrollable locale="pt-br">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal_c_litigation_date = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog_c_litigation_date[idx].save(litigation.start_date)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                                <v-text-field v-model="litigation.description" prepend-icon="mdi-file-document" label="Descrição"></v-text-field>
                                <v-row class="px-3">
                                  <v-text-field v-model="litigation.court" prepend-icon="mdi-gavel" label="Foro"></v-text-field>
                                  <v-text-field v-model="litigation.county" prepend-icon="mdi-city" label="Comarca"></v-text-field>
                                </v-row>
                                <v-radio-group v-model="litigation.client_is" row>
                                  <div class="dark-grey--text mr-2">Cliente é </div>
                                  <v-radio value="author" color="indigo">
                                    <template v-slot:label>
                                      <div><strong class="indigo--text">Autor</strong></div>
                                    </template>
                                  </v-radio>
                                  <v-radio value="defendant" color="error">
                                    <template v-slot:label>
                                      <div><strong class="error--text">Réu</strong></div>
                                    </template>
                                  </v-radio>
                                </v-radio-group>
                                <v-text-field v-model="litigation.other_part" prepend-icon="mdi-account-convert" label="Outra parte"></v-text-field>
                                <v-text-field v-model="litigation.maintenance_fee" prepend-icon="mdi-currency-brl" v-currency="currency" label="Taxa de manutenção"></v-text-field>
                                <v-text-field v-model="litigation.comment" prepend-icon="mdi-chat mdi-flip-h" label="Comentários"></v-text-field>

<!-- name: string -->
<!-- description: string -->
<!-- folder: string -->
<!-- court: string -->
<!-- county: string -->
<!-- client_is: integer -->
<!-- other_part: string -->
<!-- maintenance_fee: decimal -->
<!-- comment: text -->
                                <v-layout row wrap justify-end>
                                  <!-- PASSAR PARA DENTRO DO COMPONENTE ^ -->
                                  <v-btn v-if="litigation.id" class="mx-4" text icon color="success" @click="submitSaveItem('litigation',litigation)"> <v-icon style="font-size: 20px">mdi-content-save</v-icon> </v-btn>
                                  <v-btn class="mx-4" text icon color="error" @click="remove_litigation(idx, l_idx, 'contract')"> <v-icon style="font-size: 20px">mdi-delete</v-icon> </v-btn>
                                </v-layout>
                              </v-container>
                            </v-expansion-panel-content>
                          </v-expansion-panel>

                        </v-expansion-panels>
                        <v-row class="mt-3" justify="center">
                          <v-btn text color="primary" @click="oneClient.contracts.data[idx].litigations.push({progresses_attributes:{}})" rounded><v-icon left>mdi-plus</v-icon>Processo</v-btn>
                        </v-row>

                        <v-layout row wrap justify-end>
                          <!-- PASSAR PARA DENTRO DO COMPONENTE ^ -->
                          <v-btn v-if="oneClient.contracts.data[idx].id" class="mx-4" text icon color="success" @click="submitSaveItem('contract',oneClient.contracts.data[idx])"> <v-icon style="font-size: 20px">mdi-content-save</v-icon> </v-btn>
                          <v-btn class="mx-4" text icon color="error" @click="remove_contract(idx)"> <v-icon style="font-size: 20px">mdi-delete</v-icon> </v-btn>
                        </v-layout>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row class="mt-4" justify="center">
                  <v-btn text color="primary" @click="contracts +=1" rounded><v-icon left>mdi-plus</v-icon>Contrato</v-btn>
                </v-row>
              </v-col>


              <!-- <v-divider vertical class="mr-4"></v-divider> -->
              <v-col>
                <v-subheader>Processos sem contrato</v-subheader>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(litigation, l_idx) in oneClient.litigations.data" :key="`cc-${l_idx}`" class="mt-1" style="border-radius:8px">
                    <v-expansion-panel-header>
                      <v-row align="center">
                        <div class="caption dark-grey--text mr-1">Processo: </div>
                        <div class="dark-grey--text text--darken-3">{{litigation.name}}</div>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                      <v-container grid-list-xs>
                        <v-row class="px-3">
                          <v-text-field v-model="litigation.name" prepend-icon="mdi-information" label="Número do processo"></v-text-field>
                          <v-select :items="all_progresses" v-model="litigation.progresses_attributes.name" item-text="text" item-value="value" label="Andamento" prepend-icon="mdi-debug-step-over" ></v-select>
                          <v-dialog ref="dialog_c_litigation_date" width="290px" >
                            <template v-slot:activator="{ on }">
                              <!-- <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on" ></v-text-field> -->
                              <v-text-field :value="formatDate(litigation.progresses_attributes.processed_at)" prepend-icon="mdi-calendar" label="Movimentado em" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="litigation.progresses_attributes.processed_at" scrollable locale="pt-br">
                              <v-spacer></v-spacer>
                              <!-- <v-btn text color="primary" @click="modal_c_litigation_date = false">Cancel</v-btn> -->
                              <v-btn text color="primary" @click="$refs.dialog_c_litigation_date[idx].save(litigation.progresses_attributes.processed_at)">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                          <v-text-field v-model="litigation.progresses_attributes.description" label="Descrição do andamento" prepend-icon="mdi-debug-step-over" ></v-text-field>
                          <v-text-field v-model="litigation.progresses_attributes.internal_comment" label="Comentário interno andamento" prepend-icon="mdi-debug-step-over" ></v-text-field>
                          <v-text-field v-model="litigation.folder" prepend-icon="mdi-folder-open" label="Pasta" hint="Para organização e controle interno"></v-text-field>
                        </v-row>
                        <v-dialog ref="dialog_litigation_date" v-model="modal_litigation_date"  persistent width="290px" >
                          <template v-slot:activator="{ on }">
                            <!-- <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on" ></v-text-field> -->
                            <v-text-field :value="formatDate(litigation.start_date)" prepend-icon="mdi-calendar" label="Início" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="litigation.start_date" scrollable locale="pt-br">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal_litigation_date = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog_litigation_date[l_idx].save(litigation.start_date)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                        <v-text-field v-model="litigation.description" prepend-icon="mdi-file-document" label="Descrição"></v-text-field>
                        <v-row class="px-3">
                          <v-text-field v-model="litigation.court" prepend-icon="mdi-gavel" label="Foro"></v-text-field>
                          <v-text-field v-model="litigation.county" prepend-icon="mdi-city" label="Comarca"></v-text-field>
                        </v-row>
                        <v-radio-group v-model="litigation.client_is" row>
                          <div class="dark-grey--text mr-2">Cliente é </div>
                          <v-radio value="author" color="indigo">
                            <template v-slot:label>
                              <div><strong class="indigo--text">Autor</strong></div>
                            </template>
                          </v-radio>
                          <v-radio value="defendant" color="error">
                            <template v-slot:label>
                              <div><strong class="error--text">Réu</strong></div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                        <v-text-field v-model="litigation.other_part" prepend-icon="mdi-account-convert" label="Outra parte"></v-text-field>
                        <v-text-field v-model="litigation.maintenance_fee" prepend-icon="mdi-currency-brl" v-currency="currency" label="Taxa de manutenção"></v-text-field>
                        <v-text-field v-model="litigation.comment" prepend-icon="mdi-chat mdi-flip-h" label="Comentários"></v-text-field>

                        <v-layout row wrap justify-end>
                          <!-- PASSAR PARA DENTRO DO COMPONENTE ^ -->
                          <v-btn v-if="litigation.id" class="mx-4" text icon color="success" @click="submitSaveItem('litigation', litigation)"> <v-icon style="font-size: 20px">mdi-content-save</v-icon> </v-btn>
                          <v-btn class="mx-4" text icon color="error" @click="remove_litigation(null, l_idx, 'litigation')"> <v-icon style="font-size: 20px">mdi-delete</v-icon> </v-btn>
                        </v-layout>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
                <v-row class="mt-3" justify="center">
                  <v-btn text color="primary" @click="oneClient.litigations.data.push({progresses_attributes:{}})" rounded><v-icon left>mdi-plus</v-icon>Processo</v-btn>
                </v-row>
                <v-row class="mt-4" justify="center">
                </v-row>
              </v-col>

            </v-row>

          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn text color="error">Cancelar</v-btn>
        <v-btn text color="success" @click="submitClient()"> <v-icon>mdi-content-save</v-icon> Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>
  </v-container>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
import { mask } from 'vue-the-mask'
import Api from '../../api/index'

export default {
  directives: {
    mask,
    currency: CurrencyDirective
  },
  components: {
    CardAddress: ()=> import('@/components/shared/CardAddress.vue'),
    InputPhone: ()=> import('@/components/shared/InputPhone.vue'),
  },
  data() {
    return {
      all_progresses: [
        {text: 'Despacho inicial', value: 'initial_dispatch'},
        {text: 'Citação', value: 'quote'},
        {text: 'Fase de contestação', value: 'contest_phase'},
        {text: 'Fase de impugnação', value: 'impugnation_phase'},
        {text: 'Fase de perícia', value: 'skill_phase'},
        {text: 'Saneado', value: 'sanitized'},
        {text: 'Concluso para sentença', value: 'conclusion_to_sentence'},
        {text: 'Fase recursal', value: 'appeal_phase'},
        {text: 'Execução de sentença', value: 'sentence_enforcement'},
        {text: 'Arquivado', value: 'filed'},
        {text: 'Extinto', value: 'extinct'},
        {text: 'Concluso para despacho', value: 'concluded_for_dispatch'},
        {text: 'Proferido despacho', value: 'dispatched'}
      ],
      loading: false,
      loadingText: null,
      modal_contract_date: false,
      modal_c_litigation_date: false,
      modal_litigation_date: false,
      mask_two_digits: '##',
      mask_cpf: '###.###.###-##',
      mask_cnpj: '##.###.###/####-##',
      mask_phone: '(##) ####-####',
      mask_cellphone:'(##) # ####-####',
      currency:{
        currency: null,
        locale: 'en',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      final_fee_types:[
        {name: 'Proveito econômico', value: 'benefit'},
        {name: 'Ganho', value: 'gain'},
      ],

      key: null,
      oneClient: null,

      dialog_address:false,

      panels: 0,

      validClient: true,
      contracts: 1,
    }
  },
  computed: {
    is_new() {
      return this.$route.name.includes('New')
    },
    ...mapState({
      oneClientVuex: state=> state.Client.oneClient,

      createClientWasGood: state=> state.Client.createClientWasGood,
      createClientMessage: state=> state.Client.createClientMessage,

      updateClientWasGood: state=> state.Client.updateClientWasGood,
      updateClientMessage: state=> state.Client.updateClientMessage,
    })
  },
  methods: {
    formatDate(d){
      if (!d) return null

      const [year, month, day] = d.split('-')
      return `${day}/${month}/${year}`
    },
    setupProfile() {
      // check for new or show
      if (this.is_new){
        // set the object to correct properties
        this.oneClient= {
          address:{},
          contracts: {
            data: [
              {
                litigations:[{
                  progresses_attributes:{}
                }]
              }
            ]
          },
          litigations:{
            data:[{
              progresses_attributes:{}
            }]
          },
        }
      } else {
        // console.log(this.$route.params.id);
        this.loading = true
        this.loadingText = 'Carregando'
        this.showClient(this.$route.params.id)
      }
    },
    remove_contract(i){
      //contracts
      (async () => {
				const { value: confirmation } = await this.$swal({
					title: "Excluir item?",
          type: "question",
          text: 'Essa ação é irreversível',
					showCancelButton: true,
					confirmButtonText: 'Sim',
					confirmButtonColor: '#ff9800',
					cancelButtonText: 'Não',
				})

				if (confirmation) {
          if (this.oneClient.contracts.data.length > 0){
            if (this.oneClient.contracts.data[i]){
              let item_to_delete = this.oneClient.contracts.data.splice(i,1)
              item_to_delete = item_to_delete[0]
              if (item_to_delete.id){
                Api.Item.delete(item_to_delete.id)
                  .then(response=>{
                    this.showProposal(this.$router.currentRoute.params.id)
                  })
              }
            }
          }
          this.contracts -= 1
				}
				}
			)()
    },
    remove_litigation(i, l_i, kind){
      (async () => {
				const { value: confirmation } = await this.$swal({
					title: "Excluir processo?",
          type: "question",
          text: 'Essa ação é irreversível',
					showCancelButton: true,
					confirmButtonText: 'Sim',
					confirmButtonColor: '#ff9800',
					cancelButtonText: 'Não',
				})

				if (confirmation) {
          if (kind == 'contract'){
            console.log('delete contract-litigation');
            if (this.oneClient.contracts.data[i].litigations.length > 0){
              if (this.oneClient.contracts.data[i].litigations[l_i]){
                let item_to_delete = this.oneClient.contracts.data[i].litigations.splice(l_i,1)
                item_to_delete = item_to_delete[0]
                if (item_to_delete.id){
                  Api.Contract.delete(item_to_delete.id)
                    .then(response=>{
                      this.showClient(this.$route.params.id)
                    })
                }
              }
            }
          } else if (kind == 'litigation'){
            console.log('delete only litigation');

            if (this.oneClient.litigations.data.length > 0){
              if (this.oneClient.litigations.data[l_i]){
                let item_to_delete = this.oneClient.litigations.data.splice(l_i,1)
                // console.log({item_to_delete});
                //
                item_to_delete = item_to_delete[0]
                if (item_to_delete.id){
                  Api.Litigation.delete(item_to_delete.id)
                    .then(response=>{
                      this.showClient(this.$route.params.id)
                    })
                }
              }
            }
          }
				}
				}
			)()
    },
    submitSaveItem(kind, item){
      (async () => {
				const { value: confirmation } = await this.$swal({
					title: "Salvar item?",
          type: "question",
					showCancelButton: true,
					confirmButtonText: 'Sim',
					confirmButtonColor: '#ff9800',
					cancelButtonText: 'Não',
        })

        if (confirmation){
          this.loading = true
          this.loadingText = 'Salvando'
          switch (kind) {
            case 'contract':
              Api.Contract.update(item)
                .then(response =>{
                  this.showClient(this.$route.params.id)
                })
              break;
            case 'litigation':
              Api.Litigation.update(item)
                .then(response =>{
                  this.showClient(this.$route.params.id)
                })
              break;
          }
        }
      }
      )()
    },
    submitClient(){
      if (this.$refs.formClient.validate()){
        this.loading = true
        this.loadingText ="Salvando cliente"
        if (this.is_new){
          this.oneClient.contracts.data.forEach(contract => {
            contract.total_ammount = contract.total_ammount? contract.total_ammount.replace(/,/g, '') : 0
            contract.ammount_payed = contract.ammount_payed? contract.ammount_payed.replace(/,/g, '') : 0
            contract.initial_fee_value = contract.initial_fee_value? contract.initial_fee_value.replace(/,/g, '') : 0
            if (contract.litigations){
              contract.litigations.forEach(liti => {
                liti.maintenance_fee = liti.maintenance_fee? liti.maintenance_fee.replace(/,/g, '') : 0
              });
              contract.litigations_attributes=contract.litigations
            }
          });
          this.oneClient.litigations.data.forEach(liti => {
            liti.maintenance_fee = liti.maintenance_fee? liti.maintenance_fee.replace(/,/g, '') : 0
          });
          this.oneClient.phones = this.oneClient.phones.filter(obj => obj !='')

          this.createClient(this.oneClient)
        }else {
          if (this.oneClient.contracts.data.length>0){
            this.oneClient.contracts.data.forEach(contract => {
            contract.total_ammount = contract.total_ammount? contract.total_ammount.replace(/,/g, ''): 0
            contract.ammount_payed = contract.ammount_payed? contract.ammount_payed.replace(/,/g, ''): 0
            contract.initial_fee_value = contract.initial_fee_value? contract.initial_fee_value.replace(/,/g, ''): 0
              if (contract.litigations){
                contract.litigations.forEach(liti => {
                  liti.maintenance_fee = liti.maintenance_fee? liti.maintenance_fee.replace(/,/g, '') : 0
                });
                contract.litigations_attributes=contract.litigations
              }
            });
          }
          this.oneClient.litigations.data.forEach(liti => {
            liti.maintenance_fee = liti.maintenance_fee? liti.maintenance_fee.replace(/,/g, '') : 0
          });
          this.oneClient.phones = this.oneClient.phones.filter(obj => obj !='')

          this.updateClient(this.oneClient)
        }
      }
    },
    ...mapActions({
      createClient: 'Client/create',
      updateClient: 'Client/update',
      showClient: 'Client/show',

      // function: 'Module/action'
    })
  },
  created () {
    // console.log(this.is_new)
    this.setupProfile()

  },
  watch: {
    contracts(nv,ov) {
      if (nv > ov){
        this.oneClient.contracts.data.push({litigations:[{progresses_attributes:{}}]})
      } else if (nv == false){
      }
    },
    createClientWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {
          this.loading = false
          this.loadingText = null
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Cliente ${this.oneClient.name} criado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.$router.push('/clients')
        }, 1200);
      } else if (nv == false){
        // Tratar erro na criação
        this.loading = false
        this.loadingText = null
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 5000,
          showConfirmButton: false,
          title: this.createClientMessage || 'Erro ao criar cliente',
          type: "error",
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        })
      }
    },
    updateClientWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {
          this.loading = false
          this.loadingText = null
          this.showClient(this.$route.params.id)
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Cliente ${this.oneClient.name} editado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.$router.push('/clients')
        }, 1200);
      } else if (nv == false){
        // Tratar erro na atualização
        this.loading = false
        this.loadingText = null
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 5000,
          showConfirmButton: false,
          title: this.updateClientMessage || 'Erro ao atualizar cliente',
          type: "error",
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        })
      }
    },
    oneClientVuex(nv,ov) {
      //setup parsing oneUser from vuex to local oneUser
      if (nv){
        let {addresses, client_is, comment, contracts, corporate_info, document_number, email, id, litigations, name, phones} = nv

        // contracts.data[].attributes.litigations.data[].attributes
        let contracts_attr = contracts.data.map(obj=>obj.attributes)
        let contracts_lit_attr = []
        if (contracts_attr.length>0){
          contracts_attr.forEach(contract => {
            contracts_lit_attr = [...contracts_lit_attr, ...contract.litigations.data.map(obj=>obj.attributes)]
            contract.litigations= contracts_lit_attr.length>0? contracts_lit_attr : [{}]
            contracts_lit_attr = []
          });
        } else {
          contracts_attr = [{
            litigations:[{}]
          }]
        }
        // console.log({contracts_attr});

        let litigations_attr = litigations.data.map(obj=>obj.attributes)

        this.oneClient= {
          id,
          client_is,
          name,
          corporate_info,
          document_number,
          email,
          addresses,
          address:{
            ...addresses
          },
          phones,
          comment,

          // contracts,
          contracts: {
            data: contracts_attr
          },

          // litigations,
          litigations:{
            data: litigations_attr.length>0? litigations_attr : [{}]
          },
        }
        this.contracts = this.oneClient.contracts.data.length
        setTimeout(() => {
          this.loading= false
          this.loadingText = null
        }, 1200);
      } else if (nv == false){

      }
    }
  },
}
</script>

<style scoped>

</style>